import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1fed2403"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "scene-config" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.scenarioArr, (item, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: 'scene' + index,
        class: _normalizeClass(["scene-item", item.sceneType === _ctx.activeType ? 'scene-active' : '']),
        onClick: ($event: any) => (_ctx.handleScene(item)),
        style: _normalizeStyle({
          flex:
            _ctx.scenarioArr.length &&
            _ctx.scenarioArr.length == 2 &&
            item.sceneType === _ctx.activeType
              ? 2
              : 1,
        })
      }, [
        _createElementVNode("img", {
          src: item.img,
          alt: ""
        }, null, 8, _hoisted_3),
        _createElementVNode("span", null, _toDisplayString(item.sceneName), 1)
      ], 14, _hoisted_2))
    }), 128))
  ]))
}